import React from 'react';
import us from 'us';

import SelectField from '../select-components/select-field';

interface StateSelectorProps {
  required?: boolean;
  id?: string;
  label?: string;
  name: string;
}
const options = us.STATES_AND_TERRITORIES.map((s: any) => ({
  label: s.name,
  value: s.name,
}));

export default function StateSelector({
  name,
  label,
  ...rest
}: StateSelectorProps) {
  return (
    <SelectField
      required
      name={name}
      {...rest}
      options={options}
      label="State"
      aria-label={label || name}
    />
  );
}
